<template>
    <SbsBaseSwitcher
        v-bind="baseSwitcherData"
        v-model="switcherValue"
        class="sbs-switcher"
    >
        <template #default>
            <!-- @slot Слот по-умолчанию для вставки контента перед Свитчером -->
            <slot></slot>
        </template>
        <template #append>
            <!-- @slot Слот для вставки контента после Свитчера -->
            <slot name="append"></slot>
        </template>
        <template #error>
            <!-- @slot Слот для вывода ошибок -->
            <slot
                name="error"
                v-bind="{
                    rules,
                    valid,
                    value: modelValue,
                }">
            </slot>
        </template>
    </SbsBaseSwitcher>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import validationMixin from '../../mixins/validation.js';
import { AllColors } from '../../utils/colors.js';
import SbsBaseSwitcher from './SbsBaseSwitcher.vue';

/**
 * Компонент для проекта sbs-general.
 * Используется для переключения между двумя противоположными состояниями.
 */
export default {
    name: 'SbsSwitcher',
    emits: ['update:modelValue', 'change', 'valid', 'invalid'],
    components: {
        SbsBaseSwitcher,
    },
    mixins: [themesMixin, validationMixin],
    computed: {
        switcherValue: {
            get() {
                return this.modelValue;
            },
            async set(value) {
                /**
                 * Событие `update:modelValue` срабатывает при изменении значения.
                 * В качестве параметра - значение после изменения
                 */
                this.$emit('update:modelValue', value);

                /**
                 * Событие `change` срабатывает при изменении значения.
                 * В качестве параметра - значение после изменения
                 */
                this.$emit('change', value);

                if (!this.noValidate) {
                    await this.validate(value);
                }
            },
        },
        baseSwitcherData() {
            return {
                ...this.$attrs,
                ...this.themeData,
                append: this.append,
                backgroundTheme: this.backgroundTheme,
                disabled: this.disabled,
                fullWidth: this.fullWidth,
                id: this.id,
                label: this.label,
                switcherLabelClass: this.switcherLabelClass,
                validationRules: this.validationRules,
            };
        },
    },
    inheritAttrs: false,
    props: {
        /**
         * Контент, расположенный после свитчера
         */
        append: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) свитчера
         */
        backgroundTheme: {
            type: String,
            default: AllColors.PRIMARY,
        },
        /**
         * Перевод в неактивное состояние
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Определяет будет ли свитчер занимать всю доступную ширину
         */
        fullWidth: {
            type: Boolean,
            default: false,
        },
        /**
         * Уникальный идентификатор
         */
        id: {
            type: String,
            default: '',
        },
        /**
         * Контент, расположенный до свитчера
         */
        label: {
            type: String,
            default: '',
        },
        /**
         * Класс для лейбла свитчера
         */
        switcherLabelClass: {
            type: [String, Array],
            default: '',
        },
        /**
         * Состояние свитчера (включен или нет)
         * @model
         */
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
